import { RESET, ARQUIVOS_GERAIS_FINANCAS_LIST, ARQUIVOS_GERAIS_FINANCAS_LIST_FAILED } from '../actions/Events';

export default function (state = {}, action) {
  switch (action.type) {
    case ARQUIVOS_GERAIS_FINANCAS_LIST:
      return { ...state, results: action.payload, error: null }

    case ARQUIVOS_GERAIS_FINANCAS_LIST_FAILED:
      return { ...state, results: null, error: action.payload }

    case RESET:
      return {}

    default:
      return state
  }
}

